<script>
import {mapActions, mapGetters} from "vuex";
import {
  getBusinessCardsDoc, getBusinessProfilesDoc, queryBusinessCardsCollection,
  queryEventAttendeesCollection
} from "@/shared/firebase_utils";
import {where, limit, getCountFromServer, getDocs, startAfter, query} from "firebase/firestore";
import Loading from "@/components/Loading.vue";
import UserAvatar from "@/components/UserAvatar.vue";

export default {
  name: "AttendeesAnalyticsDetails",
  components: {UserAvatar, Loading},
  data() {
    return {
      attendeeData: [],
      type: null,
      lastLoadedDocument: null,
      canLoadMore: true,
      currentEventId: null,
      headers: [
        {
          text: "",
          value: "image",
          align: "end",
        },
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Business Name",
          value: "businessName",
          align: "start",
        },
        {
          text: "Job Title",
          value: "jobTitle",
          align: "start",
        }
      ],
    }
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    breadCrumbItems() {
      if (this.currentEvent) {

        let items = [
          {
            text: "EventConnect",
            disabled: false,
            routeName: "MultiConnect",
            params: "",
          },
          {
            text: this.currentEvent.name,
            disabled: false,
            routeName: "editMultiConnect",
            params: {eventId: this.currentEvent.id},
            query: {tab: 5}
          },
          {
            text: 'Analytics',
            disabled: false,
            routeName: "editMultiConnect",
            params: {
              eventId: this.currentEvent.id,
            },
            query: {tab: 5}
          },
          {
            text: 'Attendees',
            disabled: true,
            routeName: "attendeesAnalytics",
            params: {
              eventId: this.currentEvent.id,
            },
          },
        ];
        return items;
      } else return [];
    },

    headerDetails() {
      return [
        {
          title: "Total",
          value: this.getAttendeeCountByType,
        }
      ];
    },
    getAttendeeCountByType() {
      return this.attendeeCountByType.toLocaleString();
    },
    attendeeCountByType() {
      switch (this.type) {
        case 'visible':
          return this.currentEvent.analyticsData.attendeeAnalytics.visibleAttendees;
        case 'hidden':
          return this.currentEvent.analyticsData.attendeeAnalytics.hiddenAttendees;
        case 'general':
          return (this.currentEvent.analyticsData.allAtteneesCount - this.currentEvent.analyticsData.attendeeAnalytics.speakers - this.currentEvent.analyticsData.attendeeAnalytics.partnerRepresentatives - this.currentEvent.analyticsData.attendeeAnalytics.startupScaleUpRespresentatives);
        case 'speaker':
          return this.currentEvent.analyticsData.attendeeAnalytics.speakers;
        case 'partnerRepresentatives':
          return this.currentEvent.analyticsData.attendeeAnalytics.partnerRepresentatives;
        case 'startupRepresentatives':
          return this.currentEvent.analyticsData.attendeeAnalytics.startupScaleUpRespresentatives;

      }
    },
    title() {
      switch (this.type) {
        case 'visible':
          return 'Visible Attendees';
        case 'hidden':
          return 'Hidden Attendees';
        case 'general':
          return 'General Attendees';
        case 'speaker':
          return 'Speakers';
        case 'partnerRepresentatives':
          return 'Partner Representatives';
        case 'startupRepresentatives':
          return 'StartUp Representatives';
      }
    }
  },
  methods: {
    ...mapActions(["initializeCurrentEvent"]),
    handleRoute(item) {
      if (!item.disabled) {
        let route = {name: item.routeName, params: item.params};
        if (item.query) {
          route.query = item.query;
        }
        this.$router.push(route);
      }
    },
    async getAttendeeDetails(attendee) {
      let attendeeBusinessCard;
      if (this.type === 'partnerRepresentatives' && this.type === 'startupRepresentatives') {
        const profile = await getBusinessProfilesDoc(attendee.businessProfileId);
        if (this.type === 'startupRepresentatives') {
          if (profile.data().promoterType === 'STARTUPS_AND_SCALE_UPS') {
            attendeeBusinessCard = attendee;
          }
        } else {
          attendeeBusinessCard = attendee;
        }
      } else {
        if (attendee.businessCardId) {
          attendeeBusinessCard = (await getBusinessCardsDoc(attendee.businessCardId)).data();
        }
      }
      const attendeeData = attendeeBusinessCard === undefined ? attendee : attendeeBusinessCard;
      return {
        displayImageUrl: attendeeData.displayImageUrl,
        name: attendeeData.firstName + ' ' + attendeeData.lastName,
        businessName: attendeeData.businessName ? attendeeData.businessName : '-',
        jobTitle: attendeeData.jobTitle ? attendeeData.jobTitle : '-',
        nameInitials: attendeeData.firstName[0] + attendeeData.lastName[0],
      };
    },
    async getAttendeesData() {


      let attendeesQuery = queryEventAttendeesCollection(where("eventId", "==", this.currentEventId), limit(50));
      switch (this.type) {
        case 'visible':
          attendeesQuery = query(attendeesQuery, where("stayListedOnPage", "==", true));
          break;
        case 'hidden':
          attendeesQuery = query(attendeesQuery, where("stayListedOnPage", "==", false));
          break;
        case 'general':
          attendeesQuery = query(attendeesQuery,
              where("isSpeaker", "==", false),
              where("partnerRepresentativeToken", "==", ""),
              where("isAdmin", "==", false));
          break;
        case 'speaker':
          attendeesQuery = query(attendeesQuery, where("isSpeaker", "==", true));
          break;
        case 'partnerRepresentatives':
        case 'startupRepresentatives':
          attendeesQuery = queryBusinessCardsCollection(
              where('connectedEventIds', "array-contains", this.currentEventId),
              where('partnerRepresentativeParentEventId', "==", this.currentEventId),
              limit(50)
          )
          break;
      }
      if (this.lastLoadedDocument) {
        attendeesQuery = query(attendeesQuery, startAfter(this.lastLoadedDocument));
      }
      const attendeesSnapshot = await getDocs(attendeesQuery);
      if (this.type === 'partnerRepresentatives' || this.type === 'startupRepresentatives') {
         this.canLoadMore =  this.attendeeData.length < this.attendeeCountByType;
      }else {
        if (attendeesSnapshot.size < 50) {
          this.canLoadMore = false;
        }
      }
      this.lastLoadedDocument = attendeesSnapshot.docs[attendeesSnapshot.size - 1];
      const attendees = await Promise.all(attendeesSnapshot.docs.map(doc => doc.data()).map(attendee => this.getAttendeeDetails(attendee)));
      if (this.lastLoadedDocument) {
        attendees.filter(attendee => attendee !== undefined).forEach(attendee => this.attendeeData.push(attendee));
      } else {
        this.attendeeData = attendees.filter(attendee => attendee !== undefined);
      }
    },
    async saveEvent() {
      await this.initializeCurrentEvent(this.currentEventId);
      await this.getAttendeesData();
    }
  },
  created() {
    this.currentEventId = this.$route.params.eventId;
    this.type = this.$route.query.type;
    this.saveEvent();
  }
}
</script>

<template>
  <v-container fluid :class="currentEvent == null || !this.attendeeData ? 'fill-height' : ''">
    <v-row v-if="currentEvent == null || !this.attendeeData">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-breadcrumbs :items="breadCrumbItems" large>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                :disabled="item.disabled"
                :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
                @click="handleRoute(item)"
            >
              <div
                  :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
              >
                {{ item.text }}
              </div>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>
            {{ title }}
          </v-card-title>
          <v-col>
            <v-row>
              <div v-for="item in headerDetails">
                <div style="background-color: #F6F7FC; border-radius: 6px" class="ma-4">
                  <v-row class="ma-auto px-4 py-2" align="center">
                    {{ item.title }}:{{ item.value }}
                  </v-row>
                </div>
              </div>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="attendeeData"
                :items-per-page="-1"
                hide-default-footer
            >
              <template v-slot:[`item.image`]="{ item }">
                <UserAvatar
                    :key="item.businessCardId"
                    :usersInitials="item.nameInitials"
                    :displayImageUrl="item.displayImageUrl || ''"
                />
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <span>{{ item.name  }}</span>
              </template>
              <template v-slot:[`item.businessName`]="{ item }">
                <span>{{ item.businessName }}</span>
              </template>
              <template v-slot:[`item.jobTitle`]="{ item }">
                <span>{{ item.jobTitle }}</span>
              </template>
            </v-data-table>
            <div class="pt-4 justify-end flex">
              <v-btn v-if="canLoadMore" @click="getAttendeesData" width="150"
                     color="primary"
                     depressed
                     large
                     class="text-body-1 fixed btn">Load more
              </v-btn>
            </div>

          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<style scoped>

</style>